import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Login from '../../components/Auth/Login';
import SignUp from '../../components/Auth/SignUp';
import ForgotPassword from '../../components/Auth/ForgotPassword';
import NewSubscription from '../Login/NewSubscription';
import { LandingPageStyle } from './landingPage.style';

interface LandingPageProps {}

type PageMode = 'login' | 'signup' | 'forgot-password';

const LandingPage: React.FC<LandingPageProps> = () => {
  const [loader, setLoader] = useState<boolean>(false);
  const [newSubIsModalVisible, setNewSubIsModalVisible] = useState(false);
  const [pageMode, setPageMode] = useState<PageMode>('login');
  const [loginObject, setLoginObject] = useState<any>({
    email: '',
    password: '',
  });
  const [signUpObject, setSignUpObject] = useState<any>({
    email: '',
    password: '',
  });
  const [defaultCurrency] = useState('EUR');

  const changeModal = () => {
    setPageMode(current => (current === 'login' ? 'signup' : 'login'));
  };

  const loginFn = (status: boolean) => {
    setLoader(Boolean(status));
  };

  const signUpFn = (status: boolean) => {
    setLoader(Boolean(status));
  };

  const buildAuth0RedirectUrl = (screenHint?: string) => {
    const domain = process.env.REACT_APP_AUTH0_DOMAIN;
    const client_id = process.env.REACT_APP_AUTH0;
    const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

    if (!domain || !client_id || !audience) {
      toast.error('Authentication configuration error');
      return null;
    }

    const scope = 'openid profile email';
    const response_type = 'token';
    const redirect_uri = `${window.location.origin}/shift?defaultCurrency=${defaultCurrency}`;

    return (
      `https://${domain}/authorize?` +
      `audience=${audience}&` +
      `scope=${scope}&` +
      `response_type=${response_type}&` +
      `client_id=${client_id}&` +
      `redirect_uri=${redirect_uri}` +
      (screenHint ? `&screen_hint=${screenHint}` : '')
    );
  };

  const handleSignupRedirect = () => {
    const url = buildAuth0RedirectUrl('signup');
    if (url) window.location.replace(url);
  };

  useEffect(() => {
    const alreadyVisited = localStorage.getItem('alreadyVisited');
    if (!alreadyVisited) {
      setNewSubIsModalVisible(true);
      localStorage.setItem('alreadyVisited', 'true');
    }

    const urlParams = new URLSearchParams(window.location.search);
    const openLogin = urlParams.get('openLogin');
    const openSignup = urlParams.get('openSignup');

    if (openLogin === 'true' || openSignup === 'true') {
      const newUrl = window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);

      if (openSignup === 'true') {
        setPageMode('signup');
      } else {
        setPageMode('login');
      }
    }
  }, []);

  const loginPara = (
    <p style={{ whiteSpace: 'nowrap' }}>
      Don't have an account?{' '}
      <span onClick={handleSignupRedirect} style={{ cursor: 'pointer' }}>
        Sign up
      </span>
    </p>
  );

  const signUpPara = (
    <p style={{ whiteSpace: 'nowrap' }}>
      Already have an account? <span onClick={changeModal}>Log in</span>
    </p>
  );

  const pageTitle =
    pageMode === 'signup'
      ? 'Sign Up'
      : pageMode === 'forgot-password'
        ? 'Forgot Password'
        : 'Login';

  if (localStorage.getItem('userInfo')) {
    return <Navigate to="/home" replace />;
  }

  return (
    <LandingPageStyle className="login-page-only">
      <div className="login-modal login-page-panel">
        <div className="login-heading-container">
          <h1 className="login-heading">{pageTitle}</h1>
        </div>

        {pageMode === 'login' && (
          <Login
            header="Login"
            para={loginPara}
            isOpen
            onClose={() => undefined}
            onChange={changeModal}
            onLogin={loginFn}
            setObject={setLoginObject}
            object={loginObject}
            loader={loader}
            onForgotPassword={() => setPageMode('forgot-password')}
          />
        )}

        {pageMode === 'signup' && (
          <SignUp
            header="Sign Up"
            para={signUpPara}
            isOpen
            onClose={() => undefined}
            onChange={changeModal}
            onLogin={signUpFn}
            setObject={setSignUpObject}
            object={signUpObject}
            loader={loader}
            onBackToLogin={() => setPageMode('login')}
          />
        )}

        {pageMode === 'forgot-password' && (
          <ForgotPassword
            onBackToLogin={() => setPageMode('login')}
            onClose={() => setPageMode('login')}
          />
        )}
      </div>

      <NewSubscription
        isModalVisible={newSubIsModalVisible}
        setIsModalVisible={setNewSubIsModalVisible}
      />
    </LandingPageStyle>
  );
};

export default LandingPage;
